export const columnTypes = {
    Image: 'Image',//图片
    DateTime: 'DateTime',//时间
    Date: 'Date',//日期
    UserName: 'UserName',//用户名 
    I18nString: "I18nString", // 多语言
    EnumOptions: 'EnumOptions', //自定义
    Boolean: 'Boolean' //布尔值
}